import { useStore } from 'hooks/useStore';
import { observer } from 'mobx-react';
import OOCDashboard from './OOCDashboard';
import OOCCreateEdit from './OOCCreateEdit';
import OOCCommunicate from './OOCCommunicate';
import OOCSCReview from './OOCSCReview';
import OOCHistory from './OOCHistory';

const OOCForecast = () => {
  const { OOCStore } = useStore();
  const { currentScreen } = OOCStore;

  const renderScreen = () => {
    switch (currentScreen) {
      case 'dashboard':
        return <OOCDashboard />;
      case 'create':
      case 'edit':
        return <OOCCreateEdit />;
      case 'communicate':
        return <OOCCommunicate />;
      case 'sc-review':
        return <OOCSCReview />;
      case 'history':
        return <OOCHistory />;
      default:
        return <OOCDashboard />;
    }
  };

  return <div>{renderScreen()}</div>;
};

export default observer(OOCForecast);
